// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"eee92a76","104":"1ad96588","339":"f19bfc4e","572":"aacf2afb","821":"ba018d20","836":"ffe91b9d"}[chunkId] + ".chunk.css";
};